import React, { useState } from "react";

import DetailedInfoForm from "./DetailedInfoForm";
import ProductForm from "./ProductForm";
import InventoryPricingForm from "./InventoryPricingForm";
import TabsPharma from "./TabsPharma";
import { useNavigate } from "react-router-dom";
import { GoArrowLeft } from "react-icons/go";
import DiscountForm from "./DiscountForm";
import OrderBookForm from "./OrderBookForm";
 
function AddSettings() {
   const [activeTab, setActiveTab] = useState("product");
    const navigate = useNavigate();
   const handleBack = () => {
    navigate(-1);
  }; 
  const tabButtonStyle = (tabName) => ({
    flex: 1,
    textAlign: "center",
    padding: "5px",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
    borderBottom:
      activeTab === tabName ? "3px solid #1db954" : "3px solid transparent",
    color: activeTab === tabName ? "#1db954" : "#333",
    transition: "all 0.3s ease",
  });


  // const tabData = [
  //   { title: "Product", content: <ProductForm onNext={() => setActiveTab(1)}/> },
  //   { title: "Discount", content: <DiscountForm onNext={() => setActiveTab(1)}/> },
  //   { title: "Order Book", content: <OrderBookForm onNext={() => setActiveTab(1)}/> },
    


  // ];

  return (
    <div
      style={{
        
        backgroundColor: "#fff",
        overflow: "hidden",
      }}
    >
      {/* Tabs Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          
          height: "38px", // reduced height
        alignItems: "center", 
          
        }}
      >
        <div
          style={tabButtonStyle("product")}
          onClick={() => setActiveTab("product")}
        >
          Product
        </div>
        <div
          style={tabButtonStyle("discount")}
          onClick={() => setActiveTab("discount")}
        >
          Discount
        </div>
        <div
          style={tabButtonStyle("orderbook")}
          onClick={() => setActiveTab("orderbook")}
        >
          Orderbook
        </div>
      </div>

      {/* Tab Content */}
      <div style={{ padding: "10px" }}>
        {activeTab === "product" && <ProductForm />}
        {activeTab === "discount" && <DiscountForm />}
        {activeTab === "orderbook" && <OrderBookForm />}
      </div>
    </div>
  );
};
  
export default AddSettings;
